<template>
  <div class="ailmBanner">
    <div class="center">
      <div class="banner-overlay1">
        <span class="title">加速企业大模型  AI 应用的落地</span>
        <p>端到端的 LLMOps：模型的微调、提示</p>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'AiLMBanner',
  }
</script>

<style>
  .ailmBanner {
    width: 100%;
    height: 38.49vw;
    margin-top: 72px;
    overflow-y: hidden;
    background-image: url("../assets/images/ailmbanner.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .ailmBanner .center {
    width: auto !important;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding-left: 13.54vw;
  }

  .ailmBanner .banner-overlay1 {
    padding-top: 12.5vw;
    color: #FFFFFF;
    text-align: left;
  }


  .ailmBanner .banner-overlay1 .title {
    width: auto;
    height: 63px;
    font-size: 50px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 63px;
    display: inline-block;
  }

  .ailmBanner .banner-overlay1 p {
    width: auto;
    height: 40px;
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 40px;
    opacity: 0.7;
    margin-top: 21px;
  }

  .ailmBanner .btn-contactUs {
    margin-top: 4.53vw;
    cursor: pointer;
    color: #ffffff;
    width: 168px;
    height: 58px;
    border-radius: 29px;
    background: linear-gradient(90deg, rgba(39, 46, 63, 0.38) 0%, rgba(33, 36, 51, 0.34) 100%), url('../assets/images/svg/btnborder.svg');
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 400;
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/AiLMBanner.vue